import { Button } from '@/components/ui/button';
import { ColumnProps } from '@/components/ui/data-table';
import { OptionProps } from '@/types/questionnaire';

export function OptionColumns(): ColumnProps<OptionProps & { id: number }>[] {
  return [
    {
      field: 'label',
      header: 'Options Text',
    },
    {
      field: 'value',
      header: 'Identifier',
    },
    {
      header: 'Actions',
      render: () => (
        <div className="flex gap-2">
          <Button size={'sm'} variant={'link'}>
            Edit
          </Button>
          <Button size={'sm'} variant={'link'}>
            Delete
          </Button>
        </div>
      ),
    },
  ];
}
